<template>
<div class="container">
  <div class="jumbotron shadow-sm titlebox py-3 mb-3 mt-3 ">
    <div>
      <h1>BotAmp<sup><span class="small-font">ALPHA</span></sup></h1>
      <p class="intro ml-1">Compare likely bot activity in two sets of tweets</p>
      <router-link class="mr-3" to="./faq#what">What is BotAmp?</router-link>
      <router-link class="mr-3" to="./faq#how">How does BotAmp work?</router-link>
      <router-link class="mr-3" to="./faq#auth">Why do I need to login?</router-link>
    </div>
    <img class="logo" src="../assets/botampImage.png" alt="Botamp logo">
  </div>
</div>
</template>

<script>
export default {
  name: 'Header'
}
</script>

<style scoped>
.small-font {
  font-size: large;
}

h1 {
  font-size: 60px;
}

.intro {
  font-size: 25px;
}

.titlebox {
  display: flex;
  text-align: left;
  justify-content: space-around;
}

.titlebox a {
  color: rgb(153, 0, 0);
}

.logo {
  height: 100px;
}
</style>
